<template>
    <div 
        v-if="type == 'project'" 
        v-motion-fade-visible :duration="200"
        :class="`proj_year_${year}`" 
        class="project-item" 
        :style="long ? `grid-column: span 2`: ``"
        @click="onTileClick"
        role="button"
        tabindex="0"
        @keydown.enter="onTileClick"
        @keydown.space="onTileClick"
    >
        <div class="project-header">
            <img v-if="img != 'none' && img[img.length - 1] != '4'" :src="getImagePath(img)" loading="lazy" :alt="name + ' project preview'" />
            <video v-if="img != 'none' && img[img.length - 1] == '4'" autoplay loop muted playsinline>
                <source :src="getImagePath(img)" type="video/mp4">
                Your browser does not support the video tag.
            </video>
            <div class="project-title">
                <span>{{ name }}</span>
                <p>{{ tag }}</p>
            </div>
            <p>{{ desc }}</p>
        </div>
        <div class="project-footer">
            <div class="project-languages">
                <span v-for="language in languages" :key="language" :class="`language l_${language}`">
                    {{ language }}
                </span>
            </div>
            <i v-if="icon == 'github'" class="bi bi-github"></i>
            <i v-if="icon == 'weblink'" class="bi bi-globe2"></i>
            <i v-if="icon == 'link'" class="bi bi-box-arrow-up-right"></i>
        </div>
    </div>

    <div 
        class="achievement-box" 
        v-motion-fade-visible
        :class="cert ? `proj_year_${year} cert lvl_${level}` : `proj_year_${year} lvl_${level}`" 
        v-if="type == 'achievement'"
        @click="onTileClick"
    >
        <div class="achievement-icon">
            <i v-if="cert" class="bi bi-mortarboard-fill"></i>
            <i v-else class="bi bi-award-fill"></i>
        </div>

        <span v-html="name"></span>
    </div>
</template>

<script>
export default {
    name: "ProjectItem",
    props: {
        name: String,
        tag: String,
        desc: String,
        languages: Array,
        long: Boolean,
        icon: String,
        url: String,
        year: Number,
        type: String,
        cert: Boolean,
        level: Number,
        img: String
    },
    methods: {
        onTileClick() {
            this.url ? window.open(this.url, '_blank').focus() : {}
        },
        getImagePath(img) {
            try {
                return require(`../assets/projectImages/${img}`)
            } catch (e) {
                console.warn(`Image not found: ${img}`)
                return null
            }
        }
    },
}
</script>